@defer (hydrate on immediate) {
	<peps-ticketing-widget></peps-ticketing-widget>
	<peps-fullscreen-slider
		[sliders]="sliders"
	></peps-fullscreen-slider>
	<div class="flex flex-col">

		<div class="relative w-full -top-20 xs:-top-28 sm:-top-36 md:-top-20 lg:-top-32 xl:-top-36 2xl:-top-48 3xl:-top-56 pointer-events-none">
			<div class="relative">

				<div class="relative w-screen h-fit ">
					<picture class="absolute inset-0 w-full h-full">
						<source
							media="(min-width: 1920px)"
							srcset="/assets/images/background_roster_homepage_xl.avif"
						/>

						<source
							media="(min-width: 768px)"
							srcset="/assets/images/background_roster_homepage.avif"
						/>

						<img
							src="/assets/images/background_roster_homepage_mobile.avif"
							alt="Background Roster"
							class="object-cover object-top w-full"
						/>
					</picture>
				</div>

				<div class="relative flex flex-col gap-8 md:items-center pt-30">
					<div class="relative w-4/4 md:w-2/4 lg:w-2/5 xl:w-2/6 2xl:w-1/5 ml-4 3xl:translate-y-20 justify-center flex flex-row">
							<img src="/assets/images/yellow_cross.svg">
							<div class="absolute top-1/2 -translate-y-1/3 md:left-1/5">
								<h1 class="text-4xl sm:text-5xl z-30 text-left text-nowrap md:translate-x-8 uppercase text-outline">{{ 'page.home.roster.subtitle' | translate}}</h1>
								<h1 class="text-6xl sm:text-8xl z-30 text-left text-nowrap md:translate-x-8 uppercase text-outline">{{ 'page.home.roster.title' | translate }}</h1>
							</div>
					</div>
					<peps-max-button class="pointer-events-auto z-20 3xl:translate-y-20"></peps-max-button>
				</div>
			</div>
		</div>

		<div class="flex flex-col gap-20 justify-center -translate-y-5 3xl:-translate-y-20">
			<div class="flex flex-col md:flex-row justify-around items-center gap-4">
				<peps-title
					[subtitle]="'page.home.upcoming-matches.subtitle' | translate"
					[title]="'common.matches.lowercase' | translate"
				></peps-title>
				<peps-event-filter
					(filterChange)="toggleEventType($event)"
					[selectedEvents]="selectedEvents"
				></peps-event-filter>
			</div>

			<peps-upcoming-matchs
				[matches]="filteredMatches"
			></peps-upcoming-matchs>

			<div class="flex flex-col gap-10">
				<div class="flex flex-col md:flex-row justify-around items-center gap-4">
					<peps-title
						[subtitle]="'page.home.news.subtitle' | translate"
						[title]="'page.home.news.title' | translate"
					></peps-title>
					<span class="invisible sm:visible"></span>
				</div>

				<div class="flex flex-row gap-12 justify-center items-center flex-wrap">
					@for(article of articles; track article.id) {
						<peps-news-card
							[article]="article"
						></peps-news-card>
					}
				</div>

			</div>

			<div class="flex justify-center">
				<peps-button
					[text]="'page.home.goto-news' | translate"
					link="news"
				></peps-button>
			</div>


		</div>
		<peps-last-videos></peps-last-videos>
	</div>
}
